import React from 'react';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import { useSelector } from 'react-redux';
import { SearchResultContainer } from './SearchResultsPanel.styled';
import { sizes } from 'src/styles/Media.styled';
import { useTranslation } from 'react-i18next';

const SearchResultsPanel = (props) => {
    const { t } = useTranslation();
    const searchParam = useSelector((state) => state.filterReducer.searchParam);
    useEffectWithErrorLogging(() => {
        if (window.innerWidth >= sizes.smalDevice == false) {
            const calendarWrapper = document.getElementsByClassName('calender-wrapper')?.[0];
            if (calendarWrapper) {
                calendarWrapper.style.display = 'none';
            }
        }
    }, [searchParam]);

    const orders = useSelector(
        (state) => state.ordersReducer.searchCardData.orderData
    );

    return (
        <>
            {searchParam !== '' && (orders || []).length > 0 && (
                <SearchResultContainer
                    margin={props.margin}
                    marginTop={props.marginTop}
                >
                    {t('calendar.orders.searchResultsPanel.showingLabel')}{' '}
                    <span style={{ fontFamily: 'AvenirNextWorld Bold' }}>
                        {searchParam !== '' ? (orders || []).length : 0}
                    </span>{' '}
                    {(orders || []).length === 1
                        ? t('calendar.orders.searchResultsPanel.resultLabel')
                        : t(
                              'calendar.orders.searchResultsPanel.resultsLabel'
                          )}{' '}
                    {t('calendar.orders.searchResultsPanel.forLabel')}
                    <span>{' "' + searchParam?.trim() + '"'}</span>
                </SearchResultContainer>
            )}
            {(searchParam === '' || (orders || []).length === 0) && (
                <SearchResultContainer
                    margin={props.margin}
                    marginTop={props.marginTop}
                >
                    {t('calendar.orders.searchResultsPanel.noResultForMsg')}{' '}
                    <span>{'"' + searchParam?.trim() + '"'}</span>
                </SearchResultContainer>
            )}
        </>
    );
};

export default SearchResultsPanel;
